import { FETCH_ROLES, FETCH_ROLES_BY_LOAN } from '../../../utils/constants';
import api_access from '../../../api/apiInstance';

/**
 * Fetch all roles for the encompass instance
 */
export async function fetchRolesApi(): Promise<any> {
  try {
    const response = await api_access.get(FETCH_ROLES);
    return response.data;
  } catch (error) {
    console.error('Error fetching roles:', error);
    throw error;
  }
}
/**
 * Fetch all roles for the provided loan
 * @param loanId
 */
export async function fetchRolesByLoanApi(loanId: string): Promise<any> {
  try {
    const response = await api_access.get(`${FETCH_ROLES_BY_LOAN}/${loanId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching roles for loan:', error);
    throw error;
  }
}
